import dayjs from 'dayjs';
import {
  GET_TRACKING_COMPANY_REQUEST, GET_TRACKING_COMPANY_SUCCESS, GET_TRACKING_COMPANY_FAIL,
  GET_TRACKING_EVENTS_REQUEST, GET_TRACKING_EVENTS_SUCCESS, GET_TRACKING_EVENTS_FAIL,
  GET_TRACKING_EVENTS_TYPES_REQUEST, GET_TRACKING_EVENTS_TYPES_SUCCESS, GET_TRACKING_EVENTS_TYPES_FAIL,
  RESET_TRACKING_COMPANY_PEOPLE_COUNT_REQUEST, RESET_TRACKING_COMPANY_PEOPLE_COUNT_SUCCESS, RESET_TRACKING_COMPANY_PEOPLE_COUNT_FAIL
} from 'src/store/actions/trackingActions';
import { ARGOS_LOCKS_EVENTS_REQUEST, ARGOS_LOCKS_EVENTS_SUCCESS, ARGOS_LOCKS_EVENTS_FAIL } from 'src/store/actions/argosEventsActions';
import {
  TRACKING_GENERAL_EVENT, TRACKING_CALCULATION_EVENT, TRACKING_MONITORING_EVENT,
  TRACKING_RESET_MONITORING_EVENT
} from '../../socket/SocketActions';

const initialState = {
  data: [],
  history: [],
  fetching: false,
  historyFetching: false,
  lockEvent: [],
  resetFetching: false,
  eventsTypesFetching: false,
  eventsTypes: null,
  eventsListFetching: false,
  eventsList: null
};

const listToObject = (list, keyProperty) => list.reduce((counter, item) => {
  counter[item[keyProperty]] = item;
  return counter;
}, {});

const getUpdatedLockEvent = (data) => ({
  ...data,
  CurrentDateTime: dayjs().format('DD.MM.YYYY HH:mm:ss')
});

const trackingReducer = (state = initialState, action) => {
  switch (action.type) {
    case ARGOS_LOCKS_EVENTS_REQUEST:
      return ({ ...state, historyFetching: true });
    case ARGOS_LOCKS_EVENTS_SUCCESS:
      return ({
        ...state,
        historyFetching: false,
        history: action.payload,
        lockEvent: []
      });
    case ARGOS_LOCKS_EVENTS_FAIL:
      return ({ ...state, historyFetching: false });
    case GET_TRACKING_COMPANY_REQUEST:
      return ({ ...state, fetching: true });
    case GET_TRACKING_COMPANY_SUCCESS:
      return ({ ...state, fetching: false, data: action.payload });
    case GET_TRACKING_COMPANY_FAIL:
      return ({ ...state, fetching: false });
    case GET_TRACKING_EVENTS_REQUEST:
      return ({ ...state, eventsListFetching: true });
    case GET_TRACKING_EVENTS_SUCCESS:
      return ({ ...state, eventsListFetching: false, eventsList: listToObject(action.payload, 'EventId') });
    case GET_TRACKING_EVENTS_FAIL:
      return ({ ...state, eventsListFetching: false });
    case GET_TRACKING_EVENTS_TYPES_REQUEST:
      return ({ ...state, eventsTypesFetching: true });
    case GET_TRACKING_EVENTS_TYPES_SUCCESS:
      return ({ ...state, eventsTypesFetching: false, eventsTypes: listToObject(action.payload, 'Value') });
    case GET_TRACKING_EVENTS_TYPES_FAIL:
      return ({ ...state, eventsTypesFetching: false });
    case RESET_TRACKING_COMPANY_PEOPLE_COUNT_REQUEST:
      return ({ ...state, resetFetching: true });
    case RESET_TRACKING_COMPANY_PEOPLE_COUNT_SUCCESS:
      return ({ ...state, resetFetching: false });
    case RESET_TRACKING_COMPANY_PEOPLE_COUNT_FAIL:
      return ({ ...state, resetFetching: false });
    case TRACKING_GENERAL_EVENT:
      return ({ ...state, lockEvent: [...state.lockEvent, getUpdatedLockEvent(action.payload)] });
    case TRACKING_MONITORING_EVENT:
      return ({
        ...state,
        lockEvent: [...state.lockEvent, getUpdatedLockEvent(action.payload)],
        data: state.data.map((floor) => {
          if (floor.Id === action.payload.FloorId) {
            return ({
              ...floor,
              Locks: floor.Locks.map((lock) => (
                lock.Id === action.payload.LockId ? { ...lock, LockState: action.payload.LockState } : lock
              ))
            });
          }
          return floor;
        })
      });
    case TRACKING_RESET_MONITORING_EVENT:
      return ({
        ...state,
        data: state.data.map((floor) => {
          if (floor.Id === action.payload.FloorId) {
            return ({
              ...floor,
              Locks: floor.Locks.map((lock) => (lock.Id === action.payload.LockId ? { ...lock, LockState: 4 } : lock))
            });
          }
          return floor;
        })
      });
    case TRACKING_CALCULATION_EVENT: {
      const peoplesByRooms = action.payload.PeopleCounts
        ? action.payload.PeopleCounts.reduce((counter, { RoomId, PeopleCount }) => ({ ...counter, [RoomId]: PeopleCount }), {})
        : {};
      return ({
        ...state,
        lockEvent: [...state.lockEvent, getUpdatedLockEvent(action.payload)],
        data: state.data.map((floor) => {
          if (floor.Id === action.payload.FloorId) {
            return ({
              ...floor,
              Locks: floor.Locks.map((lock) => (lock.Id === action.payload.LockId
                ? { ...lock, LockState: action.payload.LockState }
                : lock)),
              Rooms: floor.Rooms.map((room) => (peoplesByRooms[room.Id] || peoplesByRooms[room.Id] === 0
                ? { ...room, PersonCount: peoplesByRooms[room.Id] }
                : room))
            });
          }
          return floor;
        })
      });
    }
    default:
      return state;
  }
};

export default trackingReducer;

// const examples = [
//   "{\"CompanyId\":499,\"FloorId\":433,\"LockId\":130,\"ArgosLockId\":3,\"LockName\":\"lock 1\",\"CardNumber\":\"18337005\",\"UserId\":0,\"UserName\":\"\",\"DepartmentId\":0,\"Department\":null,\"EventId\":64,\"EventName\":\"KeyOpen\",\"Direction\":\"in\",\"KeyboardId\":null,\"LockState\":2,\"PeopleCounts\":[{\"RoomId\":282,\"PeopleCount\":8},{\"RoomId\":284,\"PeopleCount\":0}]}",
//   "{\"CompanyId\":499,\"FloorId\":433,\"LockId\":130,\"ArgosLockId\":3,\"LockName\":\"lock 1\",\"CardNumber\":\"00000000\",\"UserId\":0,\"UserName\":\"\",\"DepartmentId\":0,\"Department\":null,\"EventId\":16,\"EventName\":\"SingleIntButton\",\"Direction\":\"out\",\"KeyboardId\":null,\"LockState\":2,\"PeopleCounts\":[{\"RoomId\":282,\"PeopleCount\":7},{\"RoomId\":284,\"PeopleCount\":1}]}",
//   "{\"CompanyId\":499,\"FloorId\":433,\"LockId\":130,\"ArgosLockId\":3,\"LockName\":\"lock 1\",\"CardNumber\":\"00000000\",\"UserId\":0,\"UserName\":\"\",\"DepartmentId\":0,\"Department\":null,\"EventId\":17,\"EventName\":\"SingleExtButton\",\"Direction\":\"out\",\"KeyboardId\":null,\"LockState\":2,\"PeopleCounts\":[{\"RoomId\":282,\"PeopleCount\":6},{\"RoomId\":284,\"PeopleCount\":2}]}"
// ];
